export default __webpack_public_path__ + "static/media/shane-bookstore.dd69088a.png";